import PageInfo from './PageInfo'

export default PageInfo
